import * as React from "react";
import { useState, useEffect } from "react";
import { format } from "date-fns";
import { ListBox } from "primereact/listbox";
import { Timeline } from "primereact/timeline";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";

// Libs
import {
    useDispatch,
    useSelector
} from "react-redux";
import {
	getUserCertificates,
	Certificate,
	createDetachedSignature,
	createHash,
	getSystemInfo,
} from "./crypto-pro-module/crypto-pro";

//Components
import { File } from "../../../../../modules/metajson-sub/src/libs/controls/Files/components/File/File";
import Field from "../../../../../modules/metajson-sub/src/libs/controls/components/Field";
import ApiClientModule from "../../../../../modules/metajson-sub/src/services/ApiClientModule";
import { createFile, createFileInstance } from "../../../../../modules/metajson-sub/src/libs/helpers/Utils";
import { SigCreatorProps } from "../../types";

export const SigCreator = (props: SigCreatorProps) => {
	const { onUpload, pdfFile } = props;
	
	const [certificates, setCertificates] = useState(null);
	const [chosenCertificate, setChosenCertificate] = useState(null);
	const [isSigned, setIsSigned] = useState(false);
	const [statusList, setStatusList] = useState([]);
	const [error, setError] = useState(null);

	const [ fileSigned ] = useSelector((state: any) => [
        state.SignGridComponentReducer.fileSigned,
    ]);

    const dispatch = useDispatch();

	const handlerChangeCertificate = (e) => {
        const certificate = certificates.find((item: Certificate) => item.thumbprint === e.value);
		setChosenCertificate(certificate);
		pushState(
			{
				message: "Выбор сертификата",
				loading: false,
			}
		);
	};

	const pushState = async (data: { message: string; loading: boolean }) => {
		const foundStatusIndex = statusList.findIndex((item) => item.message === data.message);
		if (foundStatusIndex >= 0) {
			const nextStatusList = statusList.map((item, index) => {
				if (index === foundStatusIndex) {
					return data;
				}
				return item;
			});
			setStatusList(nextStatusList);
		} else {
			setStatusList(current => [...current, data]);
		}

		return Promise.resolve();
	};

	const uploadSig = async () => {
		const apiModule = new ApiClientModule();

		await apiModule.getFileByUrl(pdfFile.url,  "arraybuffer", {
			success: async ({ data }) => {
				const hash = await createHash(data);
				const sign = await createDetachedSignature(chosenCertificate.thumbprint, hash);

				setStatusList(prevState => [
					...prevState, 
					{
						message: "Подпись файла",
						loading: false,
					}
				]);

				setIsSigned(true);
				dispatch({ type: 'SET_FILE_SIGNED', payload: {
					file: createFileInstance([sign], 'file.sig'),
					url: createFile(sign),
					name: "file.sig",
				}});
				return data;
			},
			error: (error) => {
				if (error.message) {
					setError(`${error.message}\n\nДля подробной информации обратитесь к разработчику`)
				} else {
					setError("Ошибка при подписании файла");
				}
				setIsSigned(false);
				setError("Ошибка при подписании файла");
			}
		});
	};

	useEffect(() => {
		const getCertificates = async () => {
			let certificates: Certificate[] | any;
	
			pushState({
				message: "Загрузка сертификатов",
				loading: true,
			});
	
			try {
				await getSystemInfo();
				try {
					certificates = await getUserCertificates();
					// eslint-disable-next-line guard-for-in
					for (const key in certificates) {
						// eslint-disable-next-line no-await-in-loop
						certificates[key].extra = await certificates[key].getOwnerInfo();
					};
					setStatusList([
						{
							message: "Загрузка сертификатов",
							loading: false,
						},
						{
							message: "Выбор сертификата",
							loading: true,
						}
					]);
					setCertificates(certificates);
				} catch (error) {
					setError("В системе не нашлись сертификаты");
				}
			} catch (error) {
				setError("Не установлен плагин");
			}
		};

		getCertificates().catch(console.error);
	}, []);

    return (
        <>
            <div className="certificates">
                <p>Каким сертификатом подписать файл?</p>
                <div className="certificates__list">
                    {/* TODO */}
                    {/* @ts-ignore */}
                    <ListBox
                        optionLabel="name"
                        optionValue="thumbprint"
                        options={certificates}
                        value={chosenCertificate?.thumbprint}
                        itemTemplate={(option) => (
                            <div>
                                <h5>Сертификат {option.name}</h5>
                                <h6>{option.extra[0].title}: {option.extra[0].description}</h6>
                                <h6>Действителен до: {format(new Date(option.validTo), "dd.MM.yyyy")}</h6>
                            </div>
                        )}
                        onChange={handlerChangeCertificate}
                    />
                </div>
            </div>

            {/* @ts-ignore */}
            <Divider />

            <div className="status">
                {/* @ts-ignore */}
                <Card className="status__list">
                    {/* @ts-ignore */}
                    <Timeline
                        value={statusList}
                        align="left"
                        content={(item) => item.message}
                        marker={(item) => (
                            <div
                                className="p-timeline-event-marker"
                                style={{ backgroundColor: item.loading ? "#f0ad4e" : "#5cb85c", border: "unset" }}
                            />
                        )}
                    />
                </Card>
            </div>

            {/* @ts-ignore */}
            <Divider />
            <div className="sig-file">
				<div className="form-group">
					<div className="col-xs-12 fullwidth">
						<label className="control-label">
							<div className="reportbox-content-desc">
								<span>
									Открепленная подпись
								</span>
							</div>
						</label>
					</div>
					<div className="col-xs-12" style={{ marginBottom: '20px' }}>
						<div className="input-group">
							<File
								disabled={true}
								isLoading={false}
								onChange={(e) => onUpload(e)}
								value={fileSigned}
							/>
						</div>
					</div>
				</div>
            </div>

			{
				error && (
					<div role="alert" className="alert alert-danger">
						{error}
					</div>
				)
			}

            {/* TODO */}
            {/* @ts-ignore */}
            <Divider />

			{/* @ts-ignore */}
			<Button
				label="Подписать"
				type="button"
				onClick={uploadSig}
				disabled={isSigned}
			/>
        </>
    );
};
